import React from 'react';
import { Users, UserPlus, UserCheck, UserX } from 'lucide-react';

/**
 * CustomerInsights — Customer stats: total, new, active (7d), churned (30d inactive).
 */
export default function CustomerInsights({ data }) {
    if (!data) return null;

    const items = [
        { icon: <Users size={18} />, label: 'Total Customers', value: data.total_customers, color: '#6366f1' },
        { icon: <UserPlus size={18} />, label: 'New This Month', value: data.new_this_month, color: '#22c55e' },
        { icon: <UserCheck size={18} />, label: 'Active (7 days)', value: data.active_7d, color: '#3b82f6' },
        { icon: <UserX size={18} />, label: 'Churned (30d)', value: data.churned, color: '#f59e0b' },
    ];

    return (
        <div className="analytics-card">
            <h3 className="analytics-card__title">Customer Insights</h3>
            <div className="customer-insights-grid">
                {items.map((item, i) => (
                    <div className="customer-insight-item" key={i}>
                        <div className="customer-insight-icon" style={{ color: item.color, background: `${item.color}12` }}>
                            {item.icon}
                        </div>
                        <div className="customer-insight-value">{item.value}</div>
                        <div className="customer-insight-label">{item.label}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
